import { render } from "./DesignerLayoutChild.vue?vue&type=template&id=f31988a8"
import script from "./DesignerLayoutChild.vue?vue&type=script&lang=js"
export * from "./DesignerLayoutChild.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__